<template>
  <div class="openInstitutionServices">
    <p class="title">{{ $t('openInstitutionServices.p000002') }}</p>
    <div class="main">
        <div class="item" v-for="item in serviceList" :key="item.id">
            <p class="mainTitle">{{ item.name }}</p>
            <div class="cItem" v-for="cItem in item.children" :key="cItem.id" :class="itemClass(cItem)" @click="chooseOption(cItem)">
                <img v-if="cItem.id == 3" class="icon" src="../../../assets/images/open-account/future.png" />
                <img v-else class="icon" src="../../../assets/images/open-account/security.png" />
                <div class="right">
                    <p class="text">{{ cItem.name }}</p>
                    <p class="subText">{{ cItem.content }}</p>
                </div>
                <img v-if="bgColor != 'black-theme'" class="chooseIcon" src="../../../assets/images/open-account/select.png" />
                <img v-else class="chooseIcon" src="../../../assets/images/open-account/darkChoose.png" />
            </div>
        </div>
    </div>
    <nav-buttons
        :disabled="ids.length <= 0"
        @on-next="submit"
    />
  </div>
</template>

<script>
import navButtons from '../components/navButtons.vue'

export default {
    components: { navButtons },
    data() {
        return {
            serviceList: [],
            ids: []
        }
    },
    computed: {
        itemClass() {
            return cItem => {
                return {
                    active: this.ids.includes(cItem.id),
                    disabled: cItem.level == 1
                };
            }
        },
        bgColor() {
            return this.$store.getters["common/bgColor"];
        },
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            this.openInstitutionServices();
        },
        async openInstitutionServices() {
            this.$apis.accountServerNewLists().then( res => {
                this.serviceList = res?.disabled_list || [];
            })
        },
        chooseOption(cItem) {
            // 如果已开通过就不能勾选
            if ( cItem.level == 1 ) return false;
            const index = this.ids.indexOf(cItem.id);
            if (index > -1) {
                this.ids.splice(index, 1); // 如果项存在，则移除它
            } else {
                this.ids.push(cItem.id);   // 如果项不存在，则添加它
            }
        },
        async submit() {
            if ( this.ids.length <= 0 ) return false;       // 没选中不能提交
            await this.$apis.submitOrgAccountType({ server_id: this.ids.join(",") });
            this.$apis.saveAccountOpeningInfo().then( res => {
                this.$router.push({ path: '/open-account/orgAccResult' });
            })
        }
    }
}
</script>

<style lang="less" scoped>
.openInstitutionServices {
    min-height: 100%;
    padding-bottom: 180px;
    .title {
        min-height: 88px;
        line-height: 1.2;
        display: flex;
        align-items: center;
        color: #17161c;
        font-size: 36px;
        font-weight: 500;
        height: 88px;
        padding: 14px 32px 0;
        border-bottom: #f3f3f3 solid 1px;
    }
    .main {
        .item {
            margin: 36px 32px 32px;
            .mainTitle {
                font-size: 32px;
                line-height: 32px;
                margin-bottom: 32px;
                font-weight: 500;
            }
            .cItem {
                background: #f6f7fa;
                border-radius: 24px;
                display: flex;
                align-items: center;
                padding: 45px 32px;
                position: relative;
                border: 1px solid transparent;
                &:not(:last-child) {
                    margin-bottom: 24px;
                }
                .icon {
                    width: 80px;
                    height: 80px;
                }
                .right {
                    margin-left: 16px;
                    .text {
                        font-size: 32px;
                        line-height: 32px;
                        margin-bottom: 16px;
                        font-weight: 500;
                    }
                    .subText {
                        font-size: 28px;
                        line-height: 28px;
                        color: #747377;
                    }
                }
                .chooseIcon {
                    position: absolute;
                    bottom: -2px;
                    right: -2px;
                    width: 78px;
                    height: 76px;
                    display: none;
                }
                &.active {
                    border: 1px solid #777777;
                    .chooseIcon {
                        display: block;
                    }
                }
                &.disabled {
                    opacity: .4;
                }
            }
        }
    }
}
.black-theme {
   .openInstitutionServices {
        .title {
            color: white;
            border-color: #323442;
        }
        .item {
            .mainTitle {
                color: white;
            }
            .cItem {
                background: #0a0b0f;
                .right {
                    .text {
                        color: white;
                    }
                    .subText {
                        color: #9D9D9F;
                    }
                }
                &.active {
                    border-color: #377CFB;
                }
            }
        }
   } 
}
</style>